// 印尼语（印度尼西亚）
export default {
  company: {
    deviceList: 'Daftar Perangkat',
    name: 'Karamel Film',
    desc: 'Nikmati momen indah!',
    companyName: 'Nama Toko',
    companyInfo: 'Info Pedagang',
    linkMan: 'Orang Kontak',
    contactInfo: 'Info Kontak',
    cooperationWay: 'Cara Kerja Sama',
    jointOperation: 'Usaha Patungan',
    selfOperated: 'Operasional Mandiri',
    agent: 'Agen',
    businessStatus: 'Status Bisnis',
    operating: 'Beroperasi',
    stopped: 'Ditutup',
    hasBackend: 'Backend Diaktifkan',
    backendAccount: 'Akun Backend',
    backendPassword: 'Kata Sandi Backend',
    deviceCount: 'Jumlah Mesin',
    orderData: 'Data Pesanan',
    companyRatio: 'Rasio Pedagang (%)',
    operatorRatio: 'Rasio Operator (%)',
    companyDesc: 'Deskripsi Pedagang',
    companyAddress: 'Alamat Pedagang',
    openAggregatedPay: 'Pembayaran Agregat Diaktifkan',
    thirdPayWay: 'Metode Pembayaran Pihak Ketiga',
    merchantId: 'ID Pedagang',
    merchantType: 'Jenis Pedagang',
    merchantAppid: 'Appid Pedagang',
    wechatRedirectUrl: 'URL Pengalihan Pembayaran WeChat',
    payNotifyUrl: 'URL Callback Pembayaran',
    refundNotifyUrl: 'URL Callback Pengembalian Dana',
    sqbMerchantCode: 'Kode Pedagang (Shouqianba)',
    sqbDeveloperKey: 'Kunci Pengembang Shouqianba',
    storeActiveCode: 'Kode Aktivasi Toko',
    frontendCallbackUrl: 'URL Callback Frontend',
    merchantSecret: 'Secret Pedagang',
    unit: 'buah',
    merchantLevel: 'Tingkat Pedagang',
    level2Merchant: 'Pedagang Tingkat 2',
    level3Merchant: 'Pedagang Tingkat 3',
    aggregatedPayMerchant: 'Pedagang Pembayaran Agregat',
    backendOpen: 'Backend Terbuka',
    forwardIncomingPrefix: 'Huilaimi Masuk_',
    qrCodeGenerateFailed: 'Gagal membuat kode QR, silakan coba lagi',
    invalidWebUrl: 'URL web yang diperoleh tidak valid, silakan hubungi administrator',
    noValidWebUrl: 'Tidak ada URL web valid yang diperoleh',
    fetchDataFailed: 'Gagal mengambil data, silakan coba lagi',
    browserNotSupportDownload: 'Browser Anda tidak mendukung unduh otomatis, silakan klik kanan untuk menyimpan gambar',
    downloadImageFailed: 'Gagal mengunduh gambar, silakan coba lagi',
    httpError: 'Kesalahan HTTP, kode status: {status}',
    copyCompanyName: 'Salin nama toko',
    copySuccess: 'Berhasil disalin',
    copyFail: 'Gagal menyalin'
  },
  income: {
    totalIncome: 'Total Jumlah Pesanan',
    platformIncome: 'Bagian Platform',
    companyIncome: 'Pendapatan Sistem Pedagang',
    subMerchantIncome: 'Bagian Pedagang Tingkat Tiga',
    parentIncome: 'Retensi Pedagang Tingkat Dua',
    orderCount: 'Jumlah Pesanan',
    subMerchantIncomeDetail: 'Rincian Pendapatan Pedagang Tingkat Tiga',
    subRatioText: 'Retensi tingkat tiga',
    subJustRatioText: 'Komisi tingkat dua',
    splitRatio: 'Rasio Pembagian',
    deviceCount: 'Jumlah Perangkat',
    deviceCode: 'Kode Perangkat',
    deviceName: 'Nama Perangkat'
  },
  login: {
    username: 'Nama pengguna',
    password: 'Kata sandi',
    login: 'Masuk',
    inputUsername: 'Silakan masukkan nama pengguna',
    inputPassword: 'Silakan masukkan kata sandi'
  },
  employee: {
    inputAccount: 'Silakan masukkan akun',
    inputName: 'Silakan masukkan nama',
    inputMobile: 'Silakan masukkan nomor ponsel',
    selectRole: 'Silakan pilih peran',
    allRoles: 'Semua peran',
    allStatus: 'Semua status',
    collapse: 'Ciutkan',
    expand: 'Perluas',
    employeeCount: 'Jumlah karyawan: ',
    addEmployee: '+ Tambah Karyawan',
    account: 'Akun',
    name: 'Nama',
    gender: 'Jenis kelamin',
    role: 'Peran',
    company: 'Perusahaan terkait',
    creator: 'Ditambahkan oleh',
    createTime: 'Waktu ditambahkan',
    devicePermission: 'Izin perangkat',
    deviceCountUnit: '{count} perangkat',
    viewAllDevices: 'Lihat semua perangkat',
    disableAccount: 'Nonaktifkan',
    resetPassword: 'Atur ulang kata sandi',
    assignDevices: 'Tetapkan perangkat',
    tip: 'Pemberitahuan',
    deleteConfirm: 'Setelah akun dihapus, akun tidak dapat lagi masuk ke sistem. Konfirmasi penghapusan?',
    employeeName: 'Nama karyawan: ',
    usernameLabel: 'Nama pengguna: ',
    currentPermission: 'Izin saat ini: ',
    assignedDevices: '{count} perangkat ditetapkan',
    selectDevice: 'Pilih perangkat: ',
    selectDevicePlaceholder: 'Silakan pilih perangkat',
    deviceHint: 'Tidak memilih perangkat berarti karyawan dapat melihat semua perangkat perusahaan',
    selectAtLeastOneDevice: 'Silakan pilih minimal 1 perangkat',
    assignSuccess: 'Perangkat berhasil ditetapkan',
    assignFailed: 'Gagal menetapkan',
    loadDeviceInfoFailed: 'Gagal memuat informasi perangkat',
    loadDeviceListFailed: 'Gagal memuat daftar perangkat',
    disableConfirmTitle: 'Yakin ingin menonaktifkan akun karyawan ini?',
    disableConfirmContent: 'Setelah dinonaktifkan, karyawan tidak dapat masuk',
    disableSuccess: 'Berhasil dinonaktifkan',
    enableConfirmTitle: 'Yakin ingin mengaktifkan akun karyawan ini?',
    enableConfirmContent: 'Setelah diaktifkan, karyawan dapat masuk',
    enableSuccess: 'Berhasil diaktifkan',
    resetPwdConfirmTitle: 'Yakin ingin mengatur ulang kata sandi karyawan ini?',
    resetPwdConfirmContent: 'Setelah diatur ulang, kata sandi akan kembali ke kata sandi default (JTphoto0515)',
    resetPwdSuccess: 'Kata sandi berhasil diatur ulang',
    addSuccess: 'Karyawan berhasil ditambahkan',
    updateSuccess: 'Karyawan berhasil diubah',
    addTitle: 'Tambah Karyawan',
    editTitle: 'Ubah Karyawan',
    accountLabel: 'Akun:',
    nameLabel: 'Nama:',
    passwordLabel: 'Kata sandi:',
    defaultPwdTip: 'Biarkan kosong untuk menggunakan kata sandi default JTphoto0515',
    defaultPwdPlaceholder: 'Biarkan kosong untuk kata sandi default',
    emailLabel: 'Email:',
    emailInvalid: 'Silakan masukkan email yang valid',
    maxLength50: 'Panjang tidak boleh lebih dari 50 karakter',
    mobileLabel: 'Ponsel:',
    mobileInvalid: 'Silakan masukkan nomor ponsel yang valid',
    roleSetting: 'Peran:',
    statusSetting: 'Status:',
    selectStatus: 'Silakan pilih status',
    genderSetting: 'Jenis kelamin:',
    selectGender: 'Silakan pilih jenis kelamin',
    deptSetting: 'Departemen:',
    remarkLabel: 'Catatan:',
    remarkPlaceholder: 'Silakan masukkan catatan',
    submit: 'Kirim',
    save: 'Simpan',
    usernameRequired: 'Nama pengguna tidak boleh kosong',
    usernameMax20: 'Nama pengguna tidak boleh lebih dari 20 karakter',
    usernameMin4: 'Nama pengguna tidak boleh kurang dari 4 karakter',
    usernameExists: 'Maaf, nama pengguna ini sudah ada',
    mobileRequired: 'Nomor ponsel tidak boleh kosong!',
    nameRequired: 'Nama tidak boleh kosong!',
    roleRequired: 'Peran tidak boleh kosong!'
  },
  homepage: {
    totalIP: 'Total IP',
    todayfc: 'Pendapatan hari ini',
    weekQOQ: 'Bandingkan minggu',
    dayQOQ: 'Bandingkan hari',
    todayCompanyIncome: 'Pendapatan toko hari ini',
    todayPlatformIncome: 'Pendapatan platform hari ini',
    todayFlow: 'Jumlah pelanggan hari ini',
    todayOrder: 'Pesanan hari ini',
    todayRefundOrder: 'Pesanan pengembalian dana hari ini',
    machineOnlineCount: 'Mesin online',
    machineOfflineCount: 'Mesin offline',
    totalPlatformIncome: 'Total pendapatan platform',
    totalOperatorIncome: 'Total bagian operator',
    totalCompanyIncome: 'Total pendapatan toko',
    totalFlow: 'Total jumlah pelanggan',
    totalOrder: 'Total pesanan',
    totalRefundOrder: 'Total pesanan pengembalian dana',
    usage: 'Penggunaan',
    incomeAmount: 'Jumlah pendapatan',
    flow: 'Jumlah pelanggan',
    orderCount: 'Jumlah pesanan',
    todayIncome: 'Pendapatan hari ini',
    lastLoginTime: 'Waktu masuk terakhir',
    canWithdrawalIncome: 'Pendapatan yang dapat ditarik',
    goodMorning: 'Selamat pagi',
    goodForenoon: 'Selamat pagi akhir',
    goodNoon: 'Selamat siang',
    goodAfternoon: 'Selamat sore',
    goodEvening: 'Selamat malam',
    welcome1: 'Minum kopi dan istirahat sebentar ☕',
    welcome2: 'Mau main LOL dengan teman?',
    welcome3: 'Mau main Honor of Kings dengan teman?',
    welcome4: 'Beberapa hari tidak bertemu jadi lebih cantik 😍',
    welcome5: 'Hari ini menulis berapa Bug 🐞?',
    welcome6: 'Hari ini ngobrol di grup?',
    welcome7: 'Hari ini makan apa yang enak?',
    welcome8: 'Hari ini kamu sudah tersenyum belum 😊?',
    welcome9: 'Hari ini membantu orang lain menyelesaikan masalah?',
    welcome10: 'Mau makan apa?',
    welcome11: 'Akhir pekan mau nonton film?',
    dateRange: '{start}~{end}',
    withdraw: 'Tarik dana',
    avatarAlt: 'Avatar',
    noDept: 'Tidak ada departemen',
    noRole: 'Tidak ada peran',
    firstVisit: 'Kunjungan pertama',
    todayIp: 'IP hari ini',
    todayVisit: 'Kunjungan hari ini',
    totalVisit: 'Total kunjungan',
    lowPaperTitle: 'Peringatan Kertas Foto Hampir Habis',
    lowPaperTip: 'Perangkat berikut memiliki sisa kertas foto kurang dari {count} lembar, harap segera isi ulang kertas agar tidak mengganggu penggunaan normal!',
    lowPaperDeviceName: 'Nama Perangkat',
    lowPaperDeviceCode: 'Kode Perangkat',
    lowPaperCount: 'Jumlah Kertas',
    lowPaperClose: 'Tutup'
  },
  device: {
    companyManage: 'Kelola toko',
    deviceManage: 'Kelola perangkat',
    totalDevices: 'Total mesin',
    all: 'Semua',
    online: 'Online',
    offline: 'Offline',
    updating: 'Sedang update',
    versionUpdate: 'Update versi',
    export: 'Ekspor',
    batchUpdate: 'Update batch',
    unbind: 'Lepas ikatan',
    bind: 'Ikatan',
    companyName: 'Nama toko',
    deviceCode: 'Kode perangkat',
    appVersion: 'Versi aplikasi',
    sn: 'Nomor seri',
    uiName: 'Nama UI',
    uiGroupName: 'Grup UI',
    photoTime: 'Waktu foto',
    intervalTime: 'Interval waktu foto',
    pagerNum: 'Jumlah kertas',
    goodsNum: 'Jumlah produk',
    filterNum: 'Jumlah filter',
    address: 'Alamat Mesin',
    orderCount: 'Jumlah pesanan',
    operation: 'Operasi',
    command: 'Perintah berhasil dikirim',
    reset: 'Reset',
    restartApp: 'Restart aplikasi',
    showMenu: 'Tampilkan menu',
    hideMenu: 'Sembunyikan menu',
    reportLog: 'Laporkan log',
    isSupperCoins: 'Dukung koin',
    unbinded: 'Sudah dilepas',
    binded: 'Sudah diikat',
    bindStatus: 'Status pengikatan',
    lastestOnlineTime: 'Waktu online terakhir',
    macAddress: 'Alamat MAC',
    resolution: 'Resolusi',
    deviceSN: 'SN perangkat',
    deviceVersion: 'Versi perangkat',
    deviceKey: 'Kunci perangkat',
    deviceIMEI: 'IMEI perangkat',
    activationCode: 'Kode aktivasi',
    leyaoyaoCode: 'Kode Leyaoyao',
    electronicPhoto: 'Foto elektronik',
    scanDownload: 'Scan untuk unduh',
    sendFriend: 'Kirim ke teman',
    templateImage: 'Gambar template',
    working: 'Sedang bekerja',
    workStatus: 'Status kerja',
    thumbnail: 'Gambar Mini',
    remoteCode: 'Kode Remote',
    belongCategory: 'Kategori',
    allMerchants: 'Semua Merchant',
    assign: 'Tetapkan',
    viewOrders: 'Lihat Pesanan',
    selectBindMerchant: 'Silakan pilih merchant yang akan ditautkan',
    pendingVendorActive: 'Aktivasi Shouqianba tertunda',
    vendorActivationCode: 'Kode aktivasi Shouqianba',
    vendorActivationCodePlaceholder: 'Silakan masukkan kode aktivasi Shouqianba',
    vendorActivationCodeRequired: 'Mohon masukkan kode aktivasi Shouqianba',
    merchantName: 'Nama Merchant',
    selectMerchantName: 'Silakan pilih nama merchant',
    assignDeviceToSub: 'Tetapkan Perangkat ke Sub-merchant',
    deviceLabel: 'Perangkat: ',
    targetMerchant: 'Merchant Tujuan',
    selectSubMerchant: 'Silakan pilih sub-merchant',
    noSubMerchant: 'Tidak ada sub-merchant tersedia, silakan buat merchant tingkat 3 terlebih dahulu',
    selectTargetMerchant: 'Silakan pilih merchant tujuan',
    assignSuccess: 'Perangkat berhasil ditetapkan',
    assignFailed: 'Gagal menetapkan perangkat',
    selectDeviceToUpdate: 'Silakan pilih perangkat yang akan diperbarui! Minimal satu',
    setupSuccess: 'Pengaturan perangkat berhasil',
    updateUI: 'Perbarui UI',
    updateApp: 'Perbarui APP',
    updateConfig: 'Perbarui Konfigurasi',
    shellExec: 'Eksekusi Perintah Shell',
    shellCommand: 'Perintah Shell',
    shellCommandPlaceholder: 'Masukkan perintah Shell yang akan dieksekusi, contoh: ls -la /tmp',
    sendShellCommand: 'Kirim Perintah Shell',
    dangerousConfirmTip: 'Perintah berbahaya memerlukan konfirmasi',
    notifiedUpdateUI: 'Perangkat diberi tahu untuk memperbarui UI',
    notifiedUpdateApp: 'Perangkat diberi tahu untuk memperbarui APP',
    notifiedUpdateConfig: 'Perangkat diberi tahu untuk memperbarui konfigurasi',
    inputShellCommand: 'Silakan masukkan perintah Shell',
    dangerousWarningTitle: '⚠️ Peringatan Operasi Berbahaya',
    dangerousWarningContent: 'Anda sedang menjalankan perintah berbahaya yang dapat menyebabkan perangkat bermasalah! Lanjutkan?',
    confirmExecute: 'Konfirmasi Eksekusi',
    commandSent: 'Perintah terkirim, harap tunggu perangkat mengeksekusi',
    sendFailed: 'Gagal mengirim',
    networkError: 'Kesalahan jaringan, silakan coba lagi nanti',
    confirmUnbind: 'Setelah dilepas, perangkat akan dipisahkan dari merchant. Apakah Anda yakin ingin melepas perangkat ini?',
    copyCompanyName: 'Salin nama toko',
    copyDeviceCode: 'Salin kode perangkat',
    copyActiveCode: 'Salin kode aktivasi',
    copySuccess: 'Berhasil disalin',
    copyFail: 'Gagal menyalin'
  },
  setting: {
    navbarColor: 'Warna bilah navigasi',
    themeColor: 'Warna tema',
    navbarPosition: 'Posisi bilah navigasi',
    fixedTopRail: 'Tetapkan bilah atas',
    fixedSidebar: 'Tetapkan bilah samping',
    multiTabMode: 'Mode multi tab',
    languageSwitching: 'Ganti bahasa',
    userCenter: 'Pusat pengguna',
    updatePassword: 'Update kata sandi',
    customSystem: 'Sesuaikan sistem',
    logout: 'Keluar',
    updateCache: 'Perbarui cache',
    refreshCacheSuccess: 'Cache berhasil diperbarui',
    refreshCacheFailed: 'Gagal memperbarui cache'
  },
  common: {
    confirm: 'Konfirmasi',
    cancel: 'Batal',
    saveSetting: 'Simpan pengaturan',
    languageChanged: 'Ganti bahasa berhasil',
    timezoneChanged: 'Ganti zona waktu berhasil',
    search: 'Cari',
    pleaseInputContent: 'Silakan masukkan konten',
    export: 'Ekspor',
    default: 'Default',
    item: 'Item',
    view: 'Lihat',
    setup: 'Pengaturan',
    status: 'Status',
    showTotal: 'Menampilkan {start} ~ {end} record, total {total} record',
    yes: 'Ya',
    no: 'Tidak',
    info: 'Info',
    sequenceNumber: 'No.',
    creationTime: 'Waktu buat',
    operation: 'Operasi',
    defaultSort: 'Nomor urut',
    type: 'Built-in',
    edit: 'Edit',
    delete: 'Hapus',
    deleteSuccess: 'Hapus berhasil',
    editSuccess: 'Edit berhasil',
    updateSuccess: 'Update berhasil',
    connectionError: 'Koneksi server abnormal, silakan coba lagi nanti!',
    reset: 'Reset',
    allCategory: 'Semua kategori',
    query: 'Query',
    add: 'Tambah',
    loadError: 'Error muat',
    isDefault: 'Default',
    setDefault: 'Set sebagai default',
    cancelDefault: 'Batal default',
    batchEdit: 'Edit batch',
    back: 'Kembali',
    uploadImg: 'Upload gambar',
    uploadImgSuccess: 'Upload gambar berhasil',
    uploadImgFailed: 'Upload gagal',
    uploadImgTips1: 'Hanya format JPG, JPEG, GIF, PNG yang diizinkan',
    uploadImgTips2: 'File melebihi batas 10M, tidak diizinkan upload',
    addSuccess: 'Tambah berhasil',
    all: 'Semua',
    batchAdd: 'Tambah Massal',
    deleteError: 'Gagal menghapus',
    deleteNoData: 'Silakan pilih data yang akan dihapus',
    disable: 'Nonaktif',
    enable: 'Aktif',
    exportError: 'Ekspor gagal!',
    exportExecl: 'Ekspor Excel',
    exportSuccess: 'Ekspor berhasil',
    noData: 'Tidak Ada Data',
    operateError: 'Operasi gagal, silakan coba lagi',
    prompt: 'Tips',
    searchError: 'Pencarian gagal',
    selectDataFirst: 'Silakan pilih stiker yang akan diekspor terlebih dahulu!',
    uploadError: 'Gagal upload',
    selectAll: 'Pilih Semua',
    totalRecords: 'Total {total} catatan',
    closeLeft: 'Tutup kiri',
    closeRight: 'Tutup kanan',
    closeOthers: 'Tutup lainnya'
  },
  template: {
    merchantManagement: 'Kelola toko',
    uiManagement: 'Kelola UI',
    newConfig: 'Bingkai baru',
    editFrame: 'Edit bingkai',
    editConfig: 'Edit konfigurasi',
    top: 'Atas',
    bottom: 'Bawah',
    builtIn: 'Built-in',
    nonBuiltIn: 'Non-built-in',
    uiConfigName: 'Nama UI',
    background: 'Latar belakang',
    wechatOfficialAccount: 'Kode QR',
    title: 'Judul',
    banner: 'Banner',
    creationTime: 'Waktu buat',
    indicatorColor: 'Warna indikator',
    type: 'Tipe',
    appliedMachines: 'Jumlah mesin diterapkan',
    freamName: 'Nama bingkai',
    editSuccess: 'Edit UI berhasil',
    tip: 'Tips',
    deletePrompt: 'Menghapus konfigurasi UI ini akan menyebabkan pengguna tidak dapat menggunakannya. Anda yakin ingin menghapus?',
    matchProduct: 'Cocokkan produk',
    selectProduct: 'Silakan pilih produk',
    templateFilePng: 'File template PNG',
    maxFileSize: 'Ukuran file maksimal 10M',
    addUploadImage: 'Tambah gambar upload',
    previewImage: 'Gambar pratinjau',
    cuttingImage: 'Gambar potongan',
    groupPhotoFrame: 'Bingkai foto bersama',
    groupPhotoYes: 'Foto bersama',
    groupPhotoNo: 'Bukan foto bersama',
    groupPhotoLensSetting: 'Pengaturan detail lensa foto bersama',
    groupPhotoConfigured: 'Foto bersama sudah dikonfigurasi',
    groupPhotoNotSet: 'Foto bersama belum diatur',
    buttonNormal: 'Tombol normal',
    buttonPressed: 'Tombol ditekan',
    buttonNormalExample: 'Contoh tombol normal',
    buttonPressedExample: 'Contoh tombol ditekan',
    reuseTemplateFile: 'Gunakan ulang file templat',
    reuseNormalButton: 'Gunakan ulang tombol normal',
    reuseAllTemplateFiles: 'Gunakan ulang semua file templat',
    addSticker: 'Tambah Stiker',
    editSticker: 'Edit Stiker',
    StickerIndexNum: 'Nomor Urut',
    onlyImage: 'Hanya gambar JPG, JPEG, GIF dan PNG yang dapat diupload',
    selectCategory: 'Silakan pilih kategori',
    selectStatus: 'Silakan pilih status',
    selectType: 'Silakan pilih jenis',
    stickerCategory: 'Kategori Stiker',
    stickerCode: 'Kode Stiker',
    stickerFileSize: 'Ukuran File',
    stickerName: 'Nama Stiker',
    stickerPreview: 'Gambar Stiker',
    stickerStatus: 'Status',
    stickerType: 'Jenis',
    staticSticker: 'Stiker Statis',
    gifSticker: 'Animasi GIF',
    videoSticker: 'Stiker Video',
    frameGroup: 'Grup Bingkai'
  },
  sticker: {
    stickerPreview: 'Gambar stiker',
    stickerCode: 'Kode stiker',
    stickerCategory: 'Kategori stiker',
    stickerType: 'Tipe',
    stickerSize: 'Ukuran',
    stickerFileSize: 'Ukuran file',
    StickerIndexNum: 'Nomor indeks',
    stickerStatus: 'Status',
    stickerName: 'Nama stiker',
    stickerOperation: 'Operasi',
    addSticker: 'Tambah stiker',
    stickerImage: 'Gambar stiker',
    stickerThumbnail: 'Thumbnail',
    stickerWidth: 'Lebar (piksel)',
    stickerHeight: 'Tinggi (piksel)',
    stickerDuration: 'Durasi',
    stickerTags: 'Tag',
    stickerDescription: 'Deskripsi',
    statusTips: 'Silakan pilih status',
    typeTips: 'Silakan pilih tipe',
    categoryTips: 'Silakan pilih kategori',
    editSticker: 'Edit stiker',
    imgPreview: 'Pratinjau gambar',
    codeCheckResultErr: '❌ Kode ini sudah ada, silakan ganti',
    codeCheckResultOk: '✅ Kode tersedia',
    inputCodeTips: 'Opsional. Perangkat membedakan jenis stiker dari sufiks kode (mis. ST2D). Disarankan huruf besar, angka, dan garis bawah',
    categoryIcon: 'Ikon kategori',
    categoryName: 'Nama kategori',
    categoryCode: 'Kode kategori',
    categoryIconPlaceholder: 'Silakan masukkan URL ikon',
    addCategory: 'Tambah kategori',
    editCategory: 'Edit kategori',
    groupNewAdd: 'Tambah grup baru',
    groupEdit: 'Edit grup',
    groupName: 'Nama grup',
    groupCode: 'Kode grup',
    groupIcon: 'Ikon grup',
    hasSticker: 'Jumlah stiker',
    groupCodePlaceholder: 'Silakan masukkan kode grup (huruf besar Inggris)',
    groupNamePlaceholder: 'Silakan masukkan nama grup',
    groupDescriptionPHR: 'Silakan masukkan deskripsi grup',
    controllerSticker: 'Kontrol',
    addFailed: 'Gagal menambahkan',
    addSuccess: 'Tambah berhasil',
    confirmDeleteSticker: 'Apakah Anda yakin ingin menghapus stiker ini?',
    deleteFailed: 'Gagal menghapus',
    deleteSuccess: 'Berhasil dihapus',
    fileDurationDesc: 'Khusus video/GIF, opsional',
    fileDurationTips: 'Hanya diperlukan untuk stiker video/GIF',
    fileSizeDesc: 'Terisi otomatis setelah upload',
    fileSizeExample: 'contoh: 51200',
    heightExample: 'contoh: 200',
    widthExample: 'contoh: 200',
    selectAtLeastOne: 'Silakan pilih minimal satu stiker',
    selectSticker: 'Pilih Stiker',
    stickerCodeDesc: 'Pengidentifikasi unik global, disarankan format STICKER_XXX',
    stickerCodeTips: 'Silakan masukkan kode stiker (unik)',
    stickerImageSize: 'Ukuran yang disarankan: 200x200 piksel, mendukung format PNG, JPG',
    stickerSlected: 'Stiker Terpilih',
    thumbnail: 'Gambar Mini',
    uploadStickerImage: 'Silakan upload gambar stiker',
    inputStickerName: 'Silakan masukkan nama stiker',
    inputStickerCode: 'Silakan masukkan kode stiker',
    codeFormatTips: 'Disarankan menggunakan format STICKER_XXX',
    codeExists: 'Kode stiker ini sudah ada, silakan ganti',
    codeValidateFailed: 'Validasi gagal',
    codeValidateError: 'Gagal memvalidasi kode, silakan coba lagi',
    codeFormatError: 'Format kode salah, disarankan menggunakan format STICKER_XXX',
    codeCheckFailedRetry: 'Validasi gagal, silakan coba lagi',
    tagsPlaceholder: 'Pisahkan beberapa tag dengan koma, contoh: senang, emoji, senyum',
    tagsDesc: 'Digunakan untuk pencarian dan pengelompokan',
    descPlaceholder: 'Silakan masukkan deskripsi stiker',
    uploadImage: 'Unggah Gambar',
    uploadThumbnail: 'Unggah Thumbnail',
    reuseStickerImage: 'Gunakan ulang gambar stiker',
    reuseStickerImageTip: 'Gambar kecil akan langsung menggunakan gambar stiker, tidak perlu unggah terpisah',
    thumbnailOptional: 'Opsional, sistem dapat membuat secara otomatis',
    thumbnailUploadSuccess: 'Thumbnail berhasil diunggah',
    selectCategoryAttr: 'Silakan pilih kategori',
    completeFormInfo: 'Silakan lengkapi informasi wajib pada formulir',
    sortOrderPlaceholder: 'Semakin kecil angka, semakin di atas',
    categoryCodePlaceholder: 'Silakan masukkan kode kategori (huruf besar Inggris)',
    categoryCodeDesc: 'Pengidentifikasi unik, disarankan huruf besar Inggris, contoh: HOT, CUTE',
    inputCategoryName: 'Silakan masukkan nama kategori',
    inputCategoryCode: 'Silakan masukkan kode kategori',
    categoryCodePatternMsg: 'Silakan masukkan huruf besar Inggris, boleh mengandung garis bawah',
    categoryCodeExists: 'Kode kategori ini sudah ada, silakan ganti',
    uploadCategoryIcon: 'Silakan unggah ikon kategori',
    sortOrderMustNumber: 'Nomor urut harus berupa angka',
    categoryDescPlaceholder: 'Silakan masukkan deskripsi kategori',
    confirmDeleteCategory: 'Konfirmasi hapus kategori ini?',
    exportDeveloping: 'Fungsi ekspor sedang dikembangkan...',
    confirmDeleteGroup: 'Apakah Anda yakin ingin menghapus grup ini?',
    selectGroupToDelete: 'Silakan pilih grup yang akan dihapus',
    inputGroupName: 'Silakan masukkan nama grup',
    groupNameTooLong: 'Nama grup tidak boleh melebihi 50 karakter',
    inputGroupCode: 'Silakan masukkan kode grup',
    groupCodeFormatMsg: 'Kode grup hanya boleh berisi huruf besar Inggris, angka, dan garis bawah',
    groupCodeTooLong: 'Kode grup tidak boleh melebihi 50 karakter',
    groupCodeInvalidOrExists: 'Format kode grup salah atau sudah ada, silakan periksa',
    uploadGroupIcon: 'Silakan unggah ikon grup',
    sortOrderInvalid: 'Silakan masukkan nomor urut yang valid (angka >= 0)',
    selectStatusEnableDisable: 'Silakan pilih status (Aktif/Nonaktif)',
    codeCheckErrorTips: '⚠️ Validasi kode gagal, silakan coba lagi nanti',
    editFailed: 'Gagal mengedit',
    operationFailedRetry: 'Operasi gagal, silakan coba lagi',
    apiException: 'Kesalahan sistem',
    selectStickerType: 'Silakan pilih jenis stiker'
  },
  filter: {
    filterName: 'Nama Filter',
    addFilter: '+ Tambah Filter',
    addFilterTitle: 'Tambah Filter',
    editFilterTitle: 'Edit Filter',
    filterPreview: 'Pratinjau Filter',
    filterOriginalImage: 'Gambar Asli Filter',
    filterResourceFile: 'File Sumber Daya Filter',
    belongCompany: 'Merchant',
    allMerchants: 'Semua Merchant',
    type: 'Jenis',
    builtIn: 'Bawaan',
    nonBuiltIn: 'Non-bawaan',
    appliedMachines: 'Mesin Terpasang',
    defaultSort: 'Urutan',
    serialNo: 'No.',
    batchCopy: 'Salin Massal',
    copy: 'Salin',
    tip: 'Tips',
    deletePrompt: 'Menghapus filter ini akan membuat mesin tidak dapat menggunakannya. Yakin ingin menghapus?',
    editFilterSuccess: 'Filter berhasil diedit',
    loadCompanyFailed: 'Gagal memuat daftar merchant',
    copyFilterSuccess: 'Filter berhasil disalin',
    copyFilterFailed: 'Gagal menyalin filter',
    batchCopySuccess: 'Filter berhasil disalin massal',
    batchCopyFailed: 'Gagal menyalin massal filter',
    selectFilterFirst: 'Silakan pilih filter yang akan disalin terlebih dahulu',
    copyToMerchantTitle: 'Salin Filter ke Merchant',
    batchCopyTitle: 'Salin Filter Massal ke Merchant',
    originalFilterName: 'Nama Filter Asli',
    newFilterName: 'Nama Filter Baru',
    inputNewFilterName: 'Silakan masukkan nama filter baru',
    targetMerchant: 'Merchant Target',
    selectCompany: 'Silakan pilih merchant',
    selectedFilters: 'Filter Terpilih',
    nameSuffix: 'Akhiran Nama Seragam',
    inputNameSuffix: 'Silakan masukkan akhiran nama seragam',
    nameSuffixTip: 'Nama filter baru = nama filter asli + akhiran ini',
    inputFilterName: 'Silakan masukkan nama filter',
    inputName: 'Silakan masukkan nama',
    selectTypeMsg: 'Silakan pilih jenis',
    inputDefaultSort: 'Silakan masukkan urutan',
    colorMatrix: 'Matriks Warna',
    whitening: 'Memutihkan',
    smoothing: 'Haluskan Kulit',
    bigEye: 'Mata Besar',
    thinFace: 'Wajah Tirus',
    smallFace: 'Wajah Kecil',
    forehead: 'Dahi',
    cheekbone: 'Tulang Pipi',
    nose: 'Hidung',
    mouth: 'Mulut',
    chin: 'Dagu',
    intensity: 'Intensitas Filter',
    sampleFullColor: 'Sampel Warna Penuh:',
    colorModeExample: 'Contoh mode foto warna',
    pngFilterExample: 'Contoh asli filter PNG',
    anyFormatMax10M: 'Format apa pun, maks. 10 MB',
    colorModeNormal: 'Mode Warna - Normal:',
    colorModePressed: 'Mode Warna - Tekan:',
    reuseAllSampleColor: 'Gunakan ulang Sampel Warna Penuh untuk semua',
    addUploadImage: 'Tambah & unggah gambar',
    uploadFile: 'Unggah File',
    reupload: 'Unggah Ulang',
    submit: 'Kirim',
    btnNormalRequired: 'Gambar Mode Warna - Normal tidak boleh kosong!',
    imageUrlRequired: 'Gambar sampel warna penuh tidak boleh kosong!',
    filterPngRequired: 'Gambar asli filter tidak boleh kosong!',
    btnSelectedRequired: 'Gambar Mode Warna - Tekan tidak boleh kosong!',
    exceed10M: 'Melebihi batas 10 MB, tidak dapat mengunggah~',
    uploadFailed: 'Gagal mengunggah'
  },
  goods: {
    productName: 'Nama produk',
    newProductName: 'Nama produk baru',
    productCode: 'Kode produk',
    preview: 'Pratinjau',
    width: 'Lebar',
    height: 'Tinggi',
    imageCount: 'Jumlah foto',
    frameTop: 'Bingkai atas',
    frameBottom: 'Bingkai bawah',
    frameLeft: 'Bingkai kiri',
    frameRight: 'Bingkai kanan',
    frameCount: 'Jumlah bingkai',
    printMode: 'Mode cetak',
    orientation: 'Orientasi',
    price: 'Harga',
    companyPrice: 'Penetapan harga',
    increasePrice: 'Cetak tambahan',
    defaultIncreasePrice: 'Harga cetak tambahan',
    companyIncreasePrice: 'Penetapan harga cetak tambahan',
    type: 'Tipe',
    deviceCount: 'Jumlah perangkat',
    operation: 'Operasi',
    confirmDelete: 'Setelah dihapus, mesin tidak akan dapat memilih produk ini. Apakah Anda yakin ingin menghapus?',
    view: 'Lihat',
    edit: 'Edit',
    delete: 'Hapus',
    search: 'Cari',
    addProduct: '+ Tambah produk',
    pleaseInputContent: 'Silakan masukkan konten pencarian',
    sequenceNumber: 'No.',
    printingMode: 'Mode cetak',
    oneCopyInDuplicate: 'Satu salinan',
    inDuplicate: 'Salinan',
    vertical: 'Vertikal',
    horizontal: 'Horizontal',
    riceConfirmation: 'Silakan masukkan harga yang benar! Hanya boleh lebih besar atau sama dengan 0.01!',
    cannotEditBuiltIn: 'Produk bawaan tidak dapat diedit. Hanya supperAdmin yang dapat mengedit',
    cannotDeleteBuiltIn: 'Produk bawaan tidak dapat dihapus. Hanya supperAdmin yang dapat menghapus',
    copy: 'Salin',
    copyProduct: 'Salin Produk',
    originalProductName: 'Nama Produk Asli',
    inputProductName: 'Silakan masukkan nama produk baru',
    selectCompany: 'Silakan pilih toko',
    copySuccess: 'Produk berhasil disalin',
    frameManage: 'Kelola Bingkai',
    orderNum: 'Urutan',
    belongCategory: 'Kategori',
    belongCompany: 'Merchant',
    subCategory: 'Subkategori',
    groupName: 'Nama Grup'
  },
  order: {
    orderManagement: 'Kelola pesanan',
    orderList: 'Daftar pesanan',
    all: 'Semua',
    paid: 'Dibayar',
    completed: 'Selesai',
    unpaid: 'Belum bayar',
    refunded: 'Dikembalikan',
    timeout: 'Timeout',
    canceled: 'Dibatalkan',
    paying: 'Sedang bayar',
    unclose: 'Belum tutup',
    closed: 'Ditutup',
    toBeReversed: 'Akan dibalik',
    reversed: 'Dibalik',
    evaluated: 'Dinilai',
    exception: 'Pengecualian',
    unknown: 'Tidak diketahui',
    payFail: 'Pembayaran gagal',
    notRefund: 'T/A',
    applyRefund: 'Ajukan pengembalian dana',
    refundInProgress: 'Sedang mengembalikan dana',
    agreeRefund: 'Setuju pengembalian dana',
    refuseRefund: 'Tolak pengembalian dana',
    refundedStatus: 'Pengembalian dana selesai',
    refundFail: 'Pengembalian dana gagal',
    cancelRefund: 'Batal pengembalian dana',
    photo: 'Foto',
    print: 'Cetak',
    remotePrint: 'Cetak Jarak Jauh',
    viewRemotePhotos: 'Lihat foto',
    remotePrintPhotos: 'Foto Cetak Jarak Jauh',
    uploadPhotos: 'Foto terunggah',
    uploadPrint: 'Unggah & Cetak',
    noPhotos: 'Tidak ada foto',
    orderNumber: 'Nomor pesanan',
    merchant: 'Toko',
    deviceNumber: 'Nomor perangkat',
    payMode: 'Metode pembayaran',
    orderType: 'Tipe pesanan',
    paymentStatus: 'Status pembayaran',
    totalPrice: 'Total harga',
    createTime: 'Waktu buat',
    payTime: 'Waktu bayar',
    quantity: 'Jumlah',
    unitPrice: 'Harga satuan',
    discountAmount: 'Jumlah diskon',
    refundStatus: 'Status pengembalian dana',
    refundReason: 'Catatan pesanan',
    operation: 'Operasi',
    export: 'Ekspor',
    orderCount: 'Jumlah pesanan',
    searchPlaceholder: 'Silakan masukkan konten pencarian',
    agree: 'Setuju pengembalian dana',
    refuse: 'Tolak pengembalian dana',
    refund: 'Pengembalian dana',
    viewPhoto: 'Lihat foto',
    gifImage: 'GIF animasi',
    confirmAgreeRefund: 'Anda yakin ingin menyetujui permohonan pengembalian dana untuk pesanan ini?',
    agreeRefundContent: 'Setelah Anda klik OK, pesanan ini akan menerima pengembalian dana.',
    agreeRefundSuccess: 'Menyetujui pengembalian dana pesanan berhasil',
    confirmRefuseRefund: 'Anda yakin ingin menolak permohonan pengembalian dana untuk pesanan ini?',
    refuseRefundContent: 'Setelah Anda klik OK, pesanan ini akan ditolak pengembalian dana.',
    refuseRefundSuccess: 'Menolak pengembalian dana pesanan berhasil',
    deviceName: 'Nama perangkat',
    viewPhotos: 'Detail Foto',
    photoDetail: 'Detail Foto',
    compositePhotos: 'Foto Gabungan',
    originalPhotos: 'Foto Asli',
    noCompositePhotos: 'Tidak ada foto gabungan',
    noOriginalPhotos: 'Tidak ada foto asli',
    frameId: 'ID Bingkai',
    copyOrderCode: 'Salin kode pesanan',
    allMerchants: 'Semua Merchant',
    allDevices: 'Semua Perangkat',
    allPayModes: 'Semua Metode Pembayaran',
    payWeixin: 'WeChat',
    payAlipay: 'Alipay',
    payShouqianba: 'Shouqianba',
    payDougong: 'Dougong',
    payYunguanjia: 'Cloud Manager',
    payLeyaoyao: 'Leyaoyao',
    payCoins: 'Koin',
    payFree: 'Gratis',
    payCoupon: 'Kode Tukar',
    payDai: 'Token',
    payCoin: 'Bayar koin',
    payCash: 'Tunai',
    payCard: 'Kartu',
    copySuccess: 'Berhasil disalin',
    copyFail: 'Gagal menyalin'
  },
  coupon: {
    all: 'Semua',
    notActivated: 'Belum Diaktifkan',
    activated: 'Diaktifkan',
    used: 'Digunakan',
    cancelled: 'Dibatalkan',
    searchPlaceholder: 'Silakan masukkan kode kupon/nama toko/nama perangkat',
    export: 'Ekspor',
    generateCoupon: 'Buat Kupon',
    qrCode: 'Kode QR',
    noQrCode: 'Tidak ada',
    clickToPreview: 'Klik untuk pratinjau',
    couponQrCode: 'Kode QR Kupon',
    clickToDownload: 'Klik gambar untuk mengunduh',
    confirmCouponInfo: 'Silakan konfirmasi informasi kupon',
    merchantName: 'Nama Toko',
    selectMerchant: 'Silakan pilih toko',
    deviceObject: 'Perangkat',
    selectDeviceFirst: 'Silakan pilih perangkat terlebih dahulu',
    couponQuantity: 'Jumlah Kupon',
    inputCouponQuantity: 'Silakan masukkan jumlah kupon',
    activateCoupon: 'Aktifkan Kupon',
    yes: 'Ya',
    no: 'Tidak',
    activate: 'Aktifkan',
    cancel: 'Batalkan',
    couponId: 'ID Kupon',
    merchant: 'Toko',
    deviceName: 'Nama Perangkat',
    couponCode: 'Kode Kupon',
    status: 'Status',
    createTime: 'Waktu Pembuatan',
    operation: 'Operasi',
    activateSuccess: 'Berhasil diaktifkan!',
    activateFailed: 'Aktivasi gagal!',
    cancelSuccess: 'Berhasil dibatalkan!',
    cancelFailed: 'Pembatalan gagal!',
    generateSuccess: 'Berhasil dibuat!',
    generateFailed: 'Pembuatan gagal!',
    generating: 'Sedang membuat kupon, harap tunggu...',
    maxCouponLimit: 'Tidak dapat membuat lebih dari 500 kupon sekaligus!',
    generateTip: 'Maksimal 500 kupon dapat dibuat dalam satu kali. Jika membutuhkan lebih, silakan buat secara bertahap. Setiap mesin dapat membuat hingga 2000 kupon per bulan.',
    selectMerchantFirst: 'Silakan pilih toko terlebih dahulu!',
    downloadSuccess: 'Unduh berhasil!',
    superCoupon: 'Kupon Super',
    setSuperCoupon: 'Atur sebagai Kupon Super',
    setSuperCouponConfirm: 'Apakah Anda yakin ingin mengatur kupon ini sebagai kupon super? Kupon super yang ada di perangkat ini akan secara otomatis diturunkan menjadi kupon biasa.',
    setSuperCouponSuccess: 'Kupon super berhasil diatur!',
    setSuperCouponFailed: 'Gagal mengatur kupon super!',
    delete: 'Hapus',
    batchDelete: 'Hapus Massal',
    deleteConfirm: 'Apakah Anda yakin ingin menghapus kupon ini? Tidak dapat dipulihkan setelah dihapus!',
    batchDeleteConfirm: 'Apakah Anda yakin ingin menghapus {count} kupon yang dipilih? Tidak dapat dipulihkan setelah dihapus!',
    deleteSuccess: 'Berhasil dihapus!',
    deleteFailed: 'Gagal menghapus!',
    selectDeleteFirst: 'Silakan pilih kupon yang akan dihapus terlebih dahulu!'
  },
  dashboard: {
    date: 'Tanggal',
    flow: 'Jumlah pelanggan',
    companyCount: 'Jumlah toko baru',
    deviceCount: 'Jumlah perangkat baru',
    photoCount: 'Jumlah pesanan foto',
    printCount: 'Jumlah pesanan cetak',
    amount: 'Total pendapatan platform',
    justSumAmount: 'Bagian platform',
    companySumAmount: 'Bagian toko',
    lineCount: 'Jumlah perangkat online',
    companyName: 'Nama toko',
    deviceCode: 'Kode perangkat',
    activeCode: 'Kode perangkat',
    deviceName: 'Nama perangkat',
    photo: 'Jumlah pesanan foto',
    print: 'Jumlah pesanan cetak',
    totalPrice: 'Total pendapatan platform',
    timeCycle: 'Waktu',
    defaultTimeFilter: 'Filter waktu default (bulan)',
    month: 'Bulan',
    week: 'Minggu',
    day: 'Hari',
    search: 'Cari',
    export: 'Ekspor',
    refund: 'Pengembalian dana',
    confirmRefund: 'Anda yakin ingin mengajukan pengembalian dana untuk pesanan ini?',
    refundContent: 'Setelah Anda klik OK, pesanan ini akan memulai permohonan pengembalian dana.',
    refundSuccess: 'Permohonan pengembalian dana pesanan berhasil',
    confirmAgreeRefund: 'Anda yakin ingin menyetujui permohonan pengembalian dana untuk pesanan ini?',
    agreeRefundContent: 'Setelah Anda klik OK, pesanan ini akan menerima pengembalian dana.',
    agreeRefundSuccess: 'Menyetujui pengembalian dana pesanan berhasil',
    confirmRefuseRefund: 'Anda yakin ingin menolak permohonan pengembalian dana untuk pesanan ini?',
    refuseRefundContent: 'Setelah Anda klik OK, pesanan ini akan ditolak pengembalian dana.',
    refuseRefundSuccess: 'Menolak pengembalian dana pesanan berhasil',
    timeRangeRequired: 'Rentang waktu tidak boleh kosong'
  },
  uiGroup: {
    uiGroupManage: 'Kelola grup UI',
    newUIGroup: 'Grup UI baru',
    searchUIName: 'Cari nama grup UI...',
    resourceType: 'Tipe sumber daya',
    adminDefine: 'Definisi admin',
    merchantDefine: 'Definisi toko',
    uiName: 'Nama UI',
    subPageCount: 'Jumlah halamanย่อย',
    downloadPackage: 'Unduh paket',
    onlyOneInCategoryCannotDelete: 'Hanya tersisa satu grup UI di kategori ini (bahasa + produk), tidak dapat dihapus',
    remark: 'Catatan',
    createTime: 'Waktu buat',
    pageManage: 'Kelola halaman',
    copy: 'Salin',
    copyPrompt: 'Anda yakin ingin menyalin grup UI ini?',
    copySuccess: 'Salin berhasil',
    copyFail: 'Salin gagal',
    copyUIGroup: 'Salin Grup UI',
    originalUIName: 'Nama Grup UI Asli',
    newUIName: 'Nama Grup UI Baru',
    inputNewUIName: 'Silakan masukkan nama grup UI baru',
    selectCompany: 'Silakan pilih perusahaan',
    companyName: 'Nama Perusahaan',
    addUIGroup: 'Grup UI baru',
    deletePrompt: 'Anda yakin ingin menghapus grup UI ini?',
    deleteSuccess: 'Hapus berhasil',
    editUIGroup: 'Edit grup UI',
    editSuccess: 'Edit berhasil',
    addSuccess: 'Tambah grup UI berhasil',
    addFail: 'Tambah grup UI gagal',
    newPage: 'Halaman baru',
    editPage: 'Edit halaman',
    addPage: 'Tambah halaman',
    pageName: 'Nama halaman',
    pageKey: 'Kunci halaman',
    pageOrder: 'Urutan halaman',
    elementCount: 'Jumlah elemen',
    elementManage: 'Kelola elemen',
    pleaseInputPageName: 'Silakan masukkan nama halaman',
    pleaseInputPageKey: 'Silakan masukkan kunci halaman',
    pleaseInputPageOrder: 'Silakan masukkan urutan halaman',
    deletePagePrompt: 'Anda yakin ingin menghapus halaman ini? Tidak dapat dipulihkan setelah dihapus!',
    addPageSuccess: 'Tambah halaman berhasil',
    addPageFail: 'Tambah halaman gagal',
    editPageSuccess: 'Edit halaman berhasil',
    editPageFail: 'Edit halaman gagal',
    deletePageSuccess: 'Hapus halaman berhasil',
    deletePageFail: 'Hapus halaman gagal',
    pageKeyExists: 'Kunci halaman sudah ada, silakan ganti',
    productType: 'Tipe produk',
    elementName: 'Nama elemen',
    elementType: 'Tipe elemen',
    allElement: 'Semua elemen',
    editElement: 'Edit elemen',
    addElement: 'Tambah elemen',
    elementValue: 'Nilai elemen',
    elementValueMsg: 'Silakan masukkan nilai elemen',
    elementKey: 'Kunci elemen',
    elementKeyMsg: 'Silakan masukkan kunci elemen',
    elementKeyPlaceholder: 'Kunci elemen tidak boleh duplikat dalam halaman yang sama, disarankan menggunakan huruf dan garis bawah',
    elementNameMsg: 'Silakan masukkan nama elemen',
    elementTypeMsg: 'Silakan pilih tipe elemen',
    elementKeyError: 'Kunci elemen sudah ada pada halaman saat ini, silakan ganti',
    elemnetDeleteTips: 'Anda yakin ingin menghapus elemen ini?',
    batchEditElement: 'Edit elemen batch',
    horizontalLayout: 'Tata letak horizontal',
    verticalLayout: 'Tata letak vertikal',
    loadingElementList: 'Sedang memuat daftar elemen...',
    allResourceType: 'Semua tipe sumber daya',
    pleaseInputUIName: 'Silakan masukkan nama grup UI',
    pleaseSelectResourceType: 'Silakan pilih tipe sumber daya',
    previewImage: 'Gambar Pratinjau',
    reupload: 'Unggah Ulang',
    uploadPreviewImage: 'Unggah Pratinjau',
    languageType: 'Bahasa',
    selectLanguageType: 'Silakan pilih bahasa',
    pageSize: 'Ukuran Halaman',
    pixelWH: 'Piksel (L×T)',
    belongCompany: 'Merchant',
    cancelDefaultConfirm: 'Apakah Anda yakin ingin membatalkan status default grup UI ini?',
    setDefaultConfirm: 'Apakah Anda yakin ingin menetapkan grup UI ini sebagai default?',
    operateSuccess: 'Operasi berhasil!',
    operateFail: 'Operasi gagal',
    onlyJpgPng: 'Hanya gambar JPG dan PNG yang dapat diunggah!',
    exceed4M: 'Ukuran gambar tidak boleh melebihi 4MB!',
    uploadSuccess: 'Unggah berhasil',
    uploadSuccessNoUrl: 'Unggah berhasil tetapi tidak dapat memperoleh URL gambar',
    inputImageUrlPlaceholder: 'Atau masukkan URL gambar secara langsung (http/https)',
    useImageUrl: 'Gunakan URL ini',
    invalidImageUrl: 'Masukkan URL gambar yang valid (diawali http:// atau https://)',
    imageUrlApplied: 'URL gambar diterapkan',
    pasteTip: 'Tips: Setelah menyalin gambar atau mengambil tangkapan layar, tekan Ctrl+V/Cmd+V untuk menempel dan mengunggahnya',
    pasteUploadSuccess: 'Gambar tempel berhasil diunggah',
    langZhCN: 'Mandarin Sederhana',
    langEn: 'Inggris',
    langFr: 'Prancis',
    langKo: 'Korea',
    langZhTW: 'Mandarin Tradisional',
    langVi: 'Vietnam',
    langAr: 'Arab',
    langBih: 'Bosnia',
    langTh: 'Thai',
    langDe: 'Jerman',
    langEs: 'Spanyol'
  },
  deviceSetup: {
    title: 'Pengaturan Perangkat',
    basicInfo: 'Informasi Dasar',
    machineModelSN: 'Kode Mesin [SN]',
    inputMachineSN: 'Silakan masukkan kode SN',
    machineName: 'Nama Mesin',
    inputMachineName: 'Silakan masukkan nama mesin',
    machineCode: 'Kode Perangkat',
    inputMachineCode: 'Silakan masukkan kode perangkat',
    machineAddress: 'Alamat Mesin',
    inputMachineAddress: 'Silakan masukkan alamat',
    activationCode: 'Kode Aktivasi',
    h5Url: 'URL Halaman H5',
    parseUrl: 'Urai URL',
    urlEditorTitle: 'Manajemen Parameter URL H5',
    urlBase: 'URL dasar',
    urlParams: 'Parameter URL',
    paramName: 'Nama parameter',
    paramValue: 'Nilai parameter',
    addParam: 'Tambah parameter',
    noParams: 'Belum ada parameter. Klik "Tambah parameter"',
    done: 'Selesai',
    pasteTip: 'Tips: Setelah menyalin gambar atau mengambil tangkapan layar, tekan Ctrl+V untuk menempel dan mengunggahnya',
    pasteUploadSuccess: 'Gambar tempel berhasil diunggah',
    filterByCompany: 'Filter berdasarkan merchant',
    customerServicePhone: 'Nomor Telepon Dukungan',
    photoAccessType: 'Metode Akses Foto',
    selectPhotoAccessType: 'Silakan pilih tipe',
    paymentMode: 'Mode Pembayaran',
    selectPaymentMode: 'Silakan pilih tipe',
    onlinePayment: 'Pembayaran Online',
    offlineCoin: 'Koin Offline',
    scanQRCode: 'Pindai Kode QR',
    addFriend: 'Tambah Teman',
    machineSettings: 'Pengaturan Mesin',
    uiGroupSelection: 'Pilihan Grup UI',
    selectUiGroup: 'Silakan pilih grup UI',
    uiSelection: 'Pilihan UI',
    searchUiName: 'Cari nama UI',
    viewAll: 'Semua',
    viewSelected: 'Terpilih Saja',
    builtIn: 'Terbina Dalam',
    notBuiltIn: 'Tidak Terbina Dalam',
    productSelection: 'Pilihan Produk',
    searchProductName: 'Cari nama produk',
    selectAll: 'Pilih Semua',
    frameSelection: 'Pilihan Bingkai',
    selectProductFirst: 'Silakan pilih produk terlebih dahulu',
    searchFrameName: 'Cari nama bingkai',
    noProductSelected: 'Silakan pilih setidaknya satu produk terlebih dahulu',
    noFrameData: 'Tidak ada data bingkai untuk produk ini',
    filterSelection: 'Pilihan Filter',
    searchFilterName: 'Cari nama filter',
    stickerGroup: 'Grup Stiker',
    searchGroupName: 'Cari nama grup',
    noStickerGroupData: 'Tidak ada data grup stiker',
    stickersCount: '{count} stiker',
    parameterSettings: 'Pengaturan Parameter',
    photoTime: 'Waktu Foto',
    seconds: 'detik',
    inputPhotoTime: 'Silakan masukkan waktu foto',
    intervalTime: 'Waktu Interval',
    inputIntervalTime: 'Silakan masukkan waktu interval',
    paperCount: 'Jumlah Kertas',
    sheets: 'lembar',
    inputPaperCount: 'Silakan masukkan jumlah kertas',
    paperCountRequired: 'Jumlah kertas wajib diisi',
    cancel: 'Batal',
    save: 'Simpan',
    selectAtLeastOneProduct: 'Silakan pilih setidaknya satu produk',
    selectAtLeastOneFilter: 'Silakan pilih setidaknya satu filter',
    paperCountMinLimit: 'Jumlah kertas tidak boleh kurang dari 50',
    serverConnectionError: 'Kesalahan koneksi server, silakan coba lagi nanti!',
    deviceThumbnail: 'Thumbnail Perangkat',
    modify: 'Ubah',
    upload: 'Unggah',
    remoteDesktopInfo: 'Info Desktop Jarak Jauh',
    remoteDesktopPlaceholder: 'Masukkan info desktop jarak jauh (kode jarak jauh)',
    format: 'Format',
    belongCategory: 'Kategori',
    selectBelongCategory: 'Silakan pilih kategori',
    onlyJpgPng: 'Hanya gambar JPG dan PNG yang dapat diunggah~',
    exceed4M: 'Melebihi batas 4M, tidak diizinkan mengunggah~',
    thumbnailUploadFailed: 'Gagal mengunggah thumbnail',
    jsonFormatErrorFormat: 'Format JSON tidak valid, tidak dapat diformat, silakan periksa dan coba lagi',
    jsonFormatError: 'Format JSON tidak valid, silakan periksa dan coba lagi',
    showName: 'Nama Tampilan Perangkat (Pindai kode QR untuk mengunduh judul halaman foto elektronik)',
    showNamePlaceholder: 'Ditampilkan sebagai judul di halaman unduh foto elektronik'
  },
  personal: {
    oldPassword: 'Kata sandi lama',
    inputOldPassword: 'Silakan masukkan kata sandi lama',
    strength: 'Kekuatan: ',
    passwordTip: 'Masukkan minimal 6 karakter. Jangan gunakan kata sandi yang mudah ditebak.',
    newPassword: 'Kata sandi baru',
    passwordPlaceholder: 'Minimal 6 karakter, perhatikan huruf besar/kecil',
    confirmPassword: 'Konfirmasi ulang',
    confirmPasswordPlaceholder: 'Konfirmasi kata sandi',
    levelLow: 'Lemah',
    levelMedium: 'Sedang',
    levelStrong: 'Kuat',
    minSixChars: 'Silakan masukkan kata sandi minimal 6 karakter',
    strengthNotEnough: 'Kekuatan kata sandi tidak cukup',
    inputPassword: 'Silakan masukkan kata sandi',
    passwordNotMatch: 'Kedua kata sandi tidak cocok',
    oldPasswordIncorrect: 'Kata sandi lama tidak benar',
    editProfile: 'Edit profil',
    updateAvatar: 'Ganti avatar',
    avatarAlt: 'Avatar',
    avatarUpdateSuccess: 'Avatar berhasil diperbarui',
    email: 'Email',
    mobile: 'Ponsel',
    dept: 'Departemen',
    gender: 'Jenis kelamin',
    description: 'Deskripsi',
    inputEmail: 'Silakan masukkan email',
    inputMobile: 'Silakan masukkan nomor ponsel',
    emailInvalid: 'Silakan masukkan email yang valid',
    emailMax: 'Panjang tidak boleh melebihi 50 karakter',
    mobileInvalid: 'Silakan masukkan nomor ponsel yang valid',
    selectGender: 'Silakan pilih jenis kelamin',
    descMax: 'Panjang tidak boleh melebihi 100 karakter',
    submit: 'Kirim',
    selectAvatar: 'Pilih avatar',
    clickToSelect: 'Klik untuk memilih',
    updatingWarning: 'Sedang mengganti avatar, jangan klik berulang',
    updateAvatarFailed: 'Gagal memperbarui avatar',
    tabHthz: 'Houtian Huazi',
    tabAl: 'Seri Ali',
    tabLm: 'LianMeng'
  },
  userInfo: {
    title: 'Info pengguna',
    account: 'Akun: ',
    role: 'Peran: ',
    noRole: 'Belum ada peran',
    male: 'Pria',
    female: 'Wanita',
    confidential: 'Rahasia',
    department: 'Departemen: ',
    noDepartment: 'Belum ada departemen',
    gender: 'Jenis kelamin: ',
    phone: 'Telepon: ',
    noPhone: 'Telepon belum terikat',
    email: 'Email: ',
    noEmail: 'Email belum terikat',
    status: 'Status: ',
    locked: 'Terkunci',
    valid: 'Aktif',
    createTime: 'Dibuat: ',
    lastLogin: 'Login terakhir: ',
    description: 'Deskripsi: '
  },
  remotePrint: {
    loading: 'Memuat...',
    expired: 'Rekaman Kedaluwarsa',
    expiredDesc: 'Rekaman unggahan ini telah kedaluwarsa. Silakan kembali ke terminal dan coba lagi.',
    completed: 'Selesai',
    completedDesc: 'Foto berhasil dikirim. Silakan tunggu di terminal untuk cetakan.',
    submitted: 'Berhasil Dikirim',
    submittedDesc: 'Foto telah dikirim ke terminal. Silakan selesaikan langkah selanjutnya di mesin.',
    orderInfo: 'Info Pesanan',
    recordCode: 'No. Rekaman',
    orderCode: 'No. Pesanan',
    product: 'Produk',
    price: 'Harga',
    expireTime: 'Kedaluwarsa Pada',
    photos: 'Foto',
    addPhoto: 'Tambah Foto',
    tipFormat: 'Hanya mendukung format JPG/PNG',
    tipSize: 'Setiap foto tidak lebih dari 3MB',
    tipExpire: 'Rekaman berlaku 5 menit, silakan unggah segera',
    submit: 'Unggah & Cetak',
    submitting: 'Mengirim...',
    noRecordCode: 'Tidak ada kode rekaman. Silakan pindai kode QR.',
    loadFailed: 'Gagal memuat. Silakan coba lagi.',
    invalidFormat: 'Hanya mendukung JPG/PNG',
    photoLimit: 'Hanya dapat mengunggah hingga {count} foto',
    fileTooLarge: 'Ukuran file tidak boleh melebihi 10MB',
    uploadFailed: 'Unggah gagal. Silakan coba lagi.',
    noPhotoUploaded: 'Silakan unggah setidaknya satu foto',
    submitFailed: 'Pengiriman gagal. Silakan coba lagi.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/id-ID.js